import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { PageHero } from "@/components/Bits";

export default function Conteudos() {
  const [articles, setArticles] = useState([]);
  useEffect(() => { api.get("/articles").then((r) => setArticles(r.data)); }, []);
  return (
    <div>
      <PageHero eyebrow="Conteúdos" title="Conhecimento técnico em refrigeração"
        subtitle="Artigos e guias para ajudar você a escolher e dimensionar corretamente." />
      <div className="mx-auto max-w-[1400px] px-4 py-16 lg:px-8">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {articles.map((a) => (
            <Link key={a.slug} to={`/conteudos/${a.slug}`} data-testid={`article-card-${a.slug}`}
              className="group flex flex-col border border-[#27272A] bg-[#151618] transition-colors duration-200 hover:border-[#FF5500]">
              <div className="relative aspect-[16/9] overflow-hidden bg-black">
                <img src={a.image} alt={a.title} className="h-full w-full object-cover opacity-80 transition-transform duration-500 group-hover:scale-105" />
              </div>
              <div className="flex flex-1 flex-col p-6">
                <span className="label-eyebrow text-[#FF5500]">{a.category}</span>
                <h3 className="font-heading mt-3 text-lg font-bold text-white">{a.title}</h3>
                <p className="mt-2 text-sm text-[#A1A1AA]">{a.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
